export default __webpack_public_path__ + "static/map-6b5641c9029de9a9480baad2a2d73ee3.png";